// Copy for the Reports page's one-click PDF export flow (Phase 2 task 2.5).
// The dialog that opens on "Export PDF" lets the executive add a short note
// and tweak the three-line narrative that leads the PDF.

export const reportsCopy = {
  // Buttons
  exportPdf: 'Export PDF',
  exportingPdf: 'Generating PDF…',

  // Dialog
  dialogTitle: 'Weekly summary PDF',
  dialogBody:
    "Review the three-line narrative below, optionally add a personal note, then export. Your note stays pinned for next time until you clear it.",

  // Field labels
  whatHappenedLabel: 'What happened',
  whatItMeansLabel: 'What it means',
  whatsNextLabel: "What's next",
  leaderNoteLabel: "Leader's note (pinned)",
  leaderNotePlaceholder: 'A sentence that frames the week. Optional.',

  // Pinning controls
  clearPinnedNote: 'Clear pinned note',
  pinnedNoteSaved: 'Pinned. This note will pre-fill next export.',

  // Status / errors
  exportFailed: 'Could not generate the PDF. Please try again.',
  pdfDisabledHeading: 'PDF export is not enabled on this plan.',
  pdfDisabledBody: 'Ask your tenant admin to upgrade the subscription to unlock PDF export.',

  // Dialog actions
  cancel: 'Cancel',
  export: 'Export',
} as const;
